export default {
      id: "close-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "assets/sprite.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./assets/svg/close.svg
// module id = ./assets/svg/close.svg
// module chunks = 0 1